<lib-dialog>
  <div class="perfil-dialog-content">
    <div class="dialog-header">
      <h3 class="dialog-title">Mi perfil</h3>
      <button type="button" class="close-btn" (click)="cerrar()" aria-label="Cerrar">✕</button>
    </div>

    <div class="perfil-dialog-body">
      @if (loading()) {
        <p class="perfil-loading">Cargando tu perfil…</p>
      } @else {
        @if (errorMsg()) {
          <div class="perfil-alert perfil-alert--error">{{ errorMsg() }}</div>
        }

        <form [formGroup]="form" (ngSubmit)="guardar()">
          <lib-grid-form preset="2cols" gap="1.1rem" wrapperClass="perfil-modal-grid">
            <lib-grid-form-item>
              <lib-field-label label="Usuario" tooltip="Identificador de tu cuenta (no editable)" />
              <lib-input
                id="pmUsername"
                formControlName="username"
                [disabled]="true"
                [externalLabel]="true"
              ></lib-input>
            </lib-grid-form-item>

            <lib-grid-form-item>
              <lib-field-label label="Tipo de documento" />
              <lib-input
                id="pmTipoDoc"
                formControlName="tipoDocumento"
                [disabled]="true"
                [externalLabel]="true"
              ></lib-input>
            </lib-grid-form-item>

            <lib-grid-form-item>
              <lib-field-label label="Número de documento" />
              <lib-input
                id="pmNumDoc"
                formControlName="numeroDocumento"
                [disabled]="true"
                [externalLabel]="true"
              ></lib-input>
            </lib-grid-form-item>

            <lib-grid-form-item>
              <lib-field-label label="Nombres" [required]="true" />
              <lib-input
                id="pmNombres"
                formControlName="nombres"
                [errorMsg]="getError('nombres')"
                [externalLabel]="true"
              ></lib-input>
            </lib-grid-form-item>

            <lib-grid-form-item>
              <lib-field-label label="Apellidos" [required]="true" />
              <lib-input
                id="pmApellidos"
                formControlName="apellidos"
                [errorMsg]="getError('apellidos')"
                [externalLabel]="true"
              ></lib-input>
            </lib-grid-form-item>

            <lib-grid-form-item>
              <lib-field-label label="Correo" [required]="true" />
              <lib-input
                id="pmEmail"
                type="email"
                formControlName="email"
                [errorMsg]="getError('email')"
                [externalLabel]="true"
              ></lib-input>
            </lib-grid-form-item>
          </lib-grid-form>

          <footer class="perfil-dialog-footer">
            <button type="button" class="perfil-btn perfil-btn--ghost" (click)="cerrar()">
              Cancelar
            </button>
            <button type="submit" class="perfil-btn perfil-btn--primary" [disabled]="saving()">
              {{ saving() ? 'Guardando…' : 'Guardar' }}
            </button>
          </footer>
        </form>
      }
    </div>
  </div>
</lib-dialog>
